import { SECONDARY_LEVEL_NAV_OPTIONS, TOP_LEVEL_NAV_OPTIONS } from '@/constants/nav';

export function buildGuidesAgentToolkitChild ({ hasAtkFirstClassNav, t, hasAgentToolkitRedirect }) {
    if (hasAtkFirstClassNav) return [];

    return [{
        name: SECONDARY_LEVEL_NAV_OPTIONS.AGENT_TOOLKIT,
        title: t('sideNav.guides.Agent Toolkit'),
        route: { name: 'AgentToolkit' },
        pendoAnalytics: 'agent-toolkit',
        hasRedirect: () => hasAgentToolkitRedirect(),
        tag: {
            type: 'beta',
            size: 'small',
        },
    }];
}

export function buildFirstClassAgentToolkitSection ({ hasAtkFirstClassNav, t, hasAgentToolkitRedirect }) {
    if (!hasAtkFirstClassNav) return [];

    return [{
        name: TOP_LEVEL_NAV_OPTIONS.AGENT_TOOLKIT,
        title: t('sideNav.agentToolkit.Agent Toolkit'),
        collapsible: true,
        iconComponent: 'AgentToolkitNavIcon',
        pendoAnalytics: 'agent-toolkit-nav-item',
        children: [
            {
                name: SECONDARY_LEVEL_NAV_OPTIONS.AGENT_TOOLKIT_OVERVIEW,
                title: t('sideNav.agentToolkit.Overview'),
                route: { name: 'AgentToolkit', query: { tab: 'overview' } },
                pendoAnalytics: 'agent-toolkit-overview',
                hasRedirect: () => hasAgentToolkitRedirect(),
            },
            {
                name: SECONDARY_LEVEL_NAV_OPTIONS.AGENT_TOOLKIT_GUIDES,
                title: t('sideNav.agentToolkit.Guides'),
                route: { name: 'AgentToolkit' },
                pendoAnalytics: 'agent-toolkit-guides',
                hasRedirect: () => hasAgentToolkitRedirect(),
            },
            {
                name: SECONDARY_LEVEL_NAV_OPTIONS.AGENT_TOOLKIT_WORKFLOW_NUDGES,
                title: t('sideNav.agentToolkit.Workflow nudges'),
                route: { name: 'AgentToolkit', query: { tab: 'workflowNudges' } },
                pendoAnalytics: 'agent-toolkit-workflow-nudges',
                hasRedirect: () => hasAgentToolkitRedirect(),
            },
            {
                name: SECONDARY_LEVEL_NAV_OPTIONS.AGENT_TOOLKIT_FRUSTRATION_SIGNALS,
                title: t('sideNav.agentToolkit.Frustration signals'),
                route: { name: 'AgentToolkit', query: { tab: 'frustrationSignals' } },
                pendoAnalytics: 'agent-toolkit-frustration-signals',
                hasRedirect: () => hasAgentToolkitRedirect(),
            },
        ],
    }];
}

export function resolveAgentToolkitActiveNavOption ({ hasAtkFirstClassNav, activeTab }) {
    if (!hasAtkFirstClassNav) {
        return {
            topOptionName: TOP_LEVEL_NAV_OPTIONS.GUIDES,
            secondaryOptionName: SECONDARY_LEVEL_NAV_OPTIONS.AGENT_TOOLKIT,
        };
    }

    let secondaryOptionName;

    switch (activeTab) {
        case 'overview':
            secondaryOptionName = SECONDARY_LEVEL_NAV_OPTIONS.AGENT_TOOLKIT_OVERVIEW;
            break;
        case 'workflowNudges':
            secondaryOptionName = SECONDARY_LEVEL_NAV_OPTIONS.AGENT_TOOLKIT_WORKFLOW_NUDGES;
            break;
        case 'frustrationSignals':
            secondaryOptionName = SECONDARY_LEVEL_NAV_OPTIONS.AGENT_TOOLKIT_FRUSTRATION_SIGNALS;
            break;
        default:
            secondaryOptionName = SECONDARY_LEVEL_NAV_OPTIONS.AGENT_TOOLKIT_GUIDES;
    }

    return {
        topOptionName: TOP_LEVEL_NAV_OPTIONS.AGENT_TOOLKIT,
        secondaryOptionName,
    };
}
